import React, { useRef, forwardRef, useImperativeHandle } from "react";
import Logo from "../../general/Logo";
import Extensions from "../extensions/Extensions";
import Chats from "./chats/Chats";
import PublicationsFilter from "../publications/PublicationsFilter";
import ExtensionsFilter from "./extensions/ExtensionsFilter";
import "./Sidebar.css";

const Sidebar = forwardRef((props, ref) => {
  const {
    selectedSection,
    onExtensionClick,
    isCollapsed,
    onChatSelect,
    selectedChatId,
    onChatsUpdate,
    setChatId,
    onShowBanner,
    onFilterChange,
    oldChats,
    setOldChats,
    onSectionChange,
    nav,
    // setNav,
    selectedDocumentIds,
    setSelectedDocumentIds,
    searchValue,
    onSearchChange,
    setSelectedChatObject,
    isCreatingChat,
    setIsCreatingChat
  } = props;

  const chatsRef = useRef(null);

  const startNewChatFromExtension = (extension, attempts = 5) => {

    if (!chatsRef.current) {
      if (attempts > 0) {
        setTimeout(() => startNewChatFromExtension(extension, attempts - 1), 200); // Wait 500ms before retrying
      } 
      return;
    }
    
    let extensionId = extension?.id || "DONA";
   
    chatsRef.current.createNewChat(extensionId);
  };



  useImperativeHandle(ref, () => ({
    startNewChatFromExtension,
  }));

  return (
    <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <div className="sidebar-header">
        <Logo />
      </div>

      <div className="sidebar-content">
        {selectedSection === "chats" && (
          <Chats
            ref={chatsRef}
            onChatSelect={onChatSelect}
            selectedChatId={selectedChatId}
            onChatsUpdate={onChatsUpdate}
            setChatId={setChatId}
            onShowBanner={onShowBanner}
            oldChats={oldChats}
            setOldChats={setOldChats}
            setSelectedChatObject={setSelectedChatObject}
            isCreatingChat={isCreatingChat}
            setIsCreatingChat={setIsCreatingChat}
          />
        )}
        {nav === "extensions" && (
          <Extensions onExtensionClick={onExtensionClick} onSectionChange={onSectionChange}
            selectedDocumentIds={selectedDocumentIds}
            setSelectedDocumentIds={setSelectedDocumentIds}
          />
        )}
        {selectedSection === "publications" && (
          <PublicationsFilter onFilterChange={onFilterChange} searchValue={searchValue} 
          onSearchChange={onSearchChange}  />
        )}
        {selectedSection === "home" && <ExtensionsFilter onFilterChange={onFilterChange} />}
      </div>


    </div>
  );
});

export default Sidebar;
